window.Result = SplashScreen.extend({

    render: function() {
        SplashScreen.prototype.render.call(this);

        var $actionButtons = this.$el.find(".action-button").detach();
        this.$el.find(".button-holder").append($actionButtons);
    },

    buildInAnimation: function() {
        this.$logos = this.$el.find(".logos");
		this.$textWrapper1 = this.$el.find(".text-wrapper h2");
		this.$textWrapper2 = this.$el.find(".text-wrapper p");
		this.$buttonHolder = this.$el.find(".button-holder");
		TweenMax.set([this.$textWrapper1, this.$textWrapper2, this.$logos, this.$buttonHolder], { 
			opacity:0,
			y: 30
		})
		
		TweenMax.staggerTo([this.$textWrapper1, this.$textWrapper2, this.$logos, this.$buttonHolder], 0.7, {
			y: 0,
            opacity: 1,
            ease: Power4.easeOut
        }, 0.1);
		return;
    },

    getContent: function(data) {
        return Handlebars.templates["result/result"](data);
    },

});
